import Top from "../modules/Top";
// import Footer from "../modules/Footer";
import PageContainer from "../modules/PageContainer";


const Main = () => {



    return (
        <>
        <div className="main">
            <Top />
            <PageContainer />
        </div>
            
           

        </>
    );
}

export default Main;